module.exports = __webpack_public_path__ + "static/media/md-flash.6566bae5.svg";